// extracted by mini-css-extract-plugin
module.exports = {"countdown":"bk","srOnly":"ck"};